import {Injectable} from "@angular/core";
import {ProduitDeclinaisonDTO} from "../../dtos/produit-declinaison-dto";
import {StockMinimum} from "../../models/gestion-stock/stock-minimum.model";
import {Observable, Subject} from "rxjs";
import {ResponseWrapper} from "../../suppliers/wrappers/response-wrapper";
import {HttpService} from "../technique/http.service";

export const URL_STOCK_MINIMUM_LIST = `dolrest/gestion-stocks/produit-declinaison/stock-minimum-list`;


@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(private httpSvc: HttpService) {}

  private subjectOpenDialogGestionStockMini = new Subject<ProduitDeclinaisonDTO>();
  openDialogGestionStockMini$ = this.subjectOpenDialogGestionStockMini.asObservable();

  announceOpenGestionStockMini(produitDeclinaison: ProduitDeclinaisonDTO) {
    this.subjectOpenDialogGestionStockMini.next(produitDeclinaison);
  }

  saveStockMinimumList(idProduitDeclinaison: number, stockMinimumList: StockMinimum[]): Observable<ResponseWrapper<StockMinimum>> {
    return this.httpSvc.post(`${URL_STOCK_MINIMUM_LIST}/${idProduitDeclinaison}`, stockMinimumList);
  }

  getStockMinimumList = (idProduitDeclinaison: number): Observable<ResponseWrapper<StockMinimum>> => {
    return this.httpSvc.get(`${URL_STOCK_MINIMUM_LIST}/${idProduitDeclinaison}`);
  }
}
